import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-approval",
  "use": "icon-approval-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-approval\">\r\n<g>\r\n\t<path d=\"M12.4,110.2h103.1c3.4-0.1,6.1-3,5.9-6.4c0-0.2,0-0.5-0.1-0.7l-2.3-12.9c-1.1-5.3-5.7-9.2-11.1-9.4H79.8l-2.3-14.6\r\n\t\tC90.6,61,99.2,48.3,99.2,34.1c-0.6-19.4-16.9-34.7-36.3-34c-18.5,0.6-33.4,15.5-34,34C28.8,48.3,37.4,61,50.5,66.3L48.8,81H20.7\r\n\t\tc-5.5,0-10.2,3.9-11.1,9.4l-2.3,12.9c-0.9,2.9,0.7,5.9,3.6,6.8C11.4,110.2,11.9,110.2,12.4,110.2L12.4,110.2z\" />\r\n\t<path d=\"M116.7,116.2H11.3c-3.2,0.3-5.7,3.1-5.4,6.3c0.2,2.9,2.5,5.2,5.4,5.4h105.4c3.2-0.3,5.7-3.1,5.4-6.3\r\n\t\tC121.9,118.8,119.6,116.5,116.7,116.2L116.7,116.2z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/approval.svg
// module id = Fsqj
// module chunks = 164